const prefix = "search/";

export const _sharedActionsConstantsSearch = {
  FETCH_SUGGESTION: prefix + "FETCH_SUGGESTION",
  FETCH_SHORTCUT_SUCCESS: prefix + "FETCH_SHORTCUT_SUCCESS",
  FETCH_DETECT_SUCCESS: prefix + "FETCH_DETECT_SUCCESS",
  FETCH_SUGGESTION_SUCCESS: "FETCH_SUGGESTION_SUCCESS",
  FETCH_LANGS_FOR_WORD_SUCCESS: prefix + "FETCH_LANGS_FOR_WORD_SUCCESS",
};

export const _sharedActionsSearch = {
  fetchSuggestion: (query, currentLang) => ({
    type: _sharedActionsConstantsSearch.FETCH_SUGGESTION,
    data: { query, currentLang },
  }),
  fetchShortcutSuccess: (data) => ({
    type: _sharedActionsConstantsSearch.FETCH_SHORTCUT_SUCCESS,
    data,
  }),
  fetchDetectSuccess: (detect) => ({
    type: _sharedActionsConstantsSearch.FETCH_DETECT_SUCCESS,
    data: { detect },
  }),
  fetchLangsForWordSuccess: (langs, query, correction) => ({
    type: _sharedActionsConstantsSearch.FETCH_LANGS_FOR_WORD_SUCCESS,
    data: { langs, query, correction },
  }),
  fetchSuggestionSuccess: (allData) => ({
    type: _sharedActionsConstantsSearch.FETCH_SUGGESTION_SUCCESS,
    data: allData,
  }),
};
